import React from 'react'

import { cn } from '@/lib/utils.ts'

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly icon?: React.ReactNode
  readonly message: string
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, message, className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center', className)}
      {...props}>
      {icon}
      <p className="max-w-[300px] text-base leading-snug text-gray-600">{message}</p>
      {children}
    </div>
  )
)
